import { useMutation } from '@tanstack/react-query';
import { ENDPOINTS } from 'config/endpoints';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import CronoError from 'crono-fe-common/types/error';

export interface DynamicsOauthInput {
  code: string;
  organizationId: string;
  environmentUrl: string;
  environmentName: string | null;
  tenantId: string | null;
}

const DYNAMICS_CONNECT_ERROR = 'Error while connecting with Dynamics 365';

// Same reasoning as the Zoho exchange: an explicit `isSuccess: false` has to
// fail the mutation here.
const dynamicsAuthCallback = async (data: DynamicsOauthInput) => {
  const request: Request = {
    url: ENDPOINTS.dynamics.authCallback,
    config: {
      method: 'post',
      data: data,
    },
  };

  const response: Response<null> = await client(request);

  if (response.data.isSuccess === false) {
    const error: CronoError = {
      message: DYNAMICS_CONNECT_ERROR,
      response: {
        status: response.status,
        data: { errors: response.data.errors ?? [] },
      },
    };
    throw error;
  }

  return response;
};

// Feedback is the inline banner on the CRM card (errors) or the Connected badge
// (success), never a toast.
const useDynamicsAuthCallback = () =>
  useMutation<Response<null>, CronoError, DynamicsOauthInput>(
    dynamicsAuthCallback,
    {
      meta: { silentAll: true },
    },
  );

export default useDynamicsAuthCallback;
